






































































































































































































































































import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import {
  BUSSINESS,
  BUSSINESS_SUBJECTS,
  SENSITIVE_WORD_TYPE,
  SENSITIVE_WORDS
} from '../../../service/constant'
import { getFinishTask, getSubTask, queryGroupUser } from '../../../service/manage'
import { getTaskInstance } from '../../../service/platform'
import ViewAuditHistory from '../../platform/components/ViewAuditHistory.vue'
import { TaskInstance } from '../../platform/types/task'
import { FORM_ITEM_LAYOUT, PROCESS_TYPES } from '../config/'
import {
  subTaskCompletedColumns,
  subTaskCompletedColumns_JZDX,
  taskCompletedColumns
} from '../config/columns'
import { column, option } from '../interface/'

@Component({ components: { ViewAuditHistory } })
export default class TaskQueryCompleted extends Vue {
  private get business() {
    return this.$store.state[BUSSINESS]
  }
  private get sensitives() {
    return this.$store.state[SENSITIVE_WORD_TYPE]
  }
  private get subjects() {
    if (!this.taskForm.business_type) return []
    const dict = this.$store.state[BUSSINESS_SUBJECTS]
    return dict[this.taskForm.business_type] || []
  }

  // 家长大学
  public get taskForm_process_type_Options(): { label: string; value: string }[] {
    if (this.taskForm.business_type == '6001' && this.taskForm.subject_id == '801') {
      return [{ label: '快捷审核', value: 'process_000000006426' }]
    } else if (this.taskForm.business_type == '7001') {
      return [
        { label: '不限', value: '' },
        { label: '一级审核', value: 'process_000000010898' },
        { label: '二级审核', value: 'process_000000011746' }
      ]
    } else {
      return [
        { label: '不限', value: '' },
        { label: '一级审核', value: 'process_000000003973' },
        { label: '二级审核', value: 'process_000000004160' }
      ]
    }
  }
  public get subTaskCompletedColumns(): column[] {
    if (this.currentParentTask.business_type == '家长大学') {
      return subTaskCompletedColumns_JZDX
    } else {
      return subTaskCompletedColumns
    }
  }

  public formItemLayout = FORM_ITEM_LAYOUT
  public isSubViewVisible = false
  public reviewer: any[] = []
  public taskCompletedColumns: column[] = taskCompletedColumns
  public taskForm = {
    resource_id: '', // 资源 ID
    task_id: '', // 接口未提供该字段
    task_name: '', // 接口未提供该字段
    business_type: '',
    subject_id: '',
    process_type: '',
    // process_type: 'first_pass',
    user_id: '',
    startRange: ['', ''], // 分配时间，接口未提供该字段
    endRange: ['', '']
  }
  public taskDataSource: any[] = []
  public taskPagination = {
    total: 0,
    current: 1,
    showTotal: (total) => `共 ${total} 条`
  }
  // 子任务
  public currentParentTask: any = {}
  public subTaskDataSource = []
  public subTaskPagination = {
    total: 0,
    current: 1,
    showTotal: (total) => `共 ${total} 条`
  }
  public subTaskRangeValue = []
  public defaultSubTaskFormValue = {
    resource_id: '',
    sample_type: '0',
    sensitive_type: '',
    range: '',
    tag: '',
    process_type: '',
    status: ''
  }
  public subTaskForm = {
    resource_id: '',
    sample_type: '0',
    sensitive_type: '',
    range: '',
    tag: '',
    process_type: '',
    status: ''
  }
  // 父任务
  public processTypes = []

  private subInstanceData: TaskInstance | {} = {} // 查看审核信息-实例数据
  private showAuditHistory = false // 是否显示审核信息modal
  private customStyle =
    'background: rgba(255,255,255,0);border-radius: 4px;border: 0;overflow: hidden;'

  @Watch('taskForm_process_type_Options')
  public onTaskForm_process_type_OptionsChange() {
    this.taskForm.process_type = this.taskForm_process_type_Options[0].value
  }
  @Watch('taskForm.business_type')
  public onBussinessChange(val) {
    if (!this.subjects || this.subjects.length == 0) return
    if (!this.subjects.map((item) => item.value).includes(this.taskForm.subject_id)) {
      setTimeout(() => {
        this.taskForm.subject_id = this.subjects[0].value
      })
    }
  }
  public handleSubTaskTableChange(pagination) {
    const parent_id = this.currentParentTask.task_id
    this.renderSubTaskList(parent_id, pagination.current)
  }
  public async mounted() {
    this.taskForm.business_type = this.business[0].value
    await this.renderReviewerList('')
    await this.renderFinishTask(1)
  }
  public renderSubTaskProcess(id) {
    this.processTypes = PROCESS_TYPES[id]
  }
  public async handleStatusChange(value) {
    this.renderReviewerList('')
  }
  public async renderReviewerList(username) {
    const options = {
      status: this.taskForm.process_type,
      username
    }
    this.reviewer = await queryGroupUser(options)
    // BUFIX ID1076985
    // this.taskForm.user_id = this.reviewer.length > 0 ? this.reviewer[0].id : ''
  }
  handleUserSearch(value) {
    this.renderReviewerList(value)
  }
  public handleTaskTableChange(pagination) {
    this.renderFinishTask(pagination.current)
  }
  public onStartRangeChange(date, dateString) {
    this.taskForm.startRange = dateString
  }
  public onEndRangeChange(date, dateString) {
    this.taskForm.endRange = dateString
  }
  public handleTaskFormSubmit(e) {
    this.renderFinishTask(1)
  }
  public async renderFinishTask(page_num) {
    const options = {
      resource_id: this.taskForm.resource_id,
      task_id: this.taskForm.task_id,
      task_name: this.taskForm.task_name,
      subject_id: Number(this.taskForm.subject_id),
      business_type: Number(this.taskForm.business_type),
      process_type: this.taskForm.process_type,
      created_start: this.taskForm.startRange[0],
      created_end: this.taskForm.startRange[1],
      finish_at: this.taskForm.endRange[0],
      finish_end: this.taskForm.endRange[1],
      user_id: this.taskForm.user_id,
      page_num,
      page_size: 10
    }
    const { list, total } = await getFinishTask(options)
    this.taskDataSource = list
    this.taskPagination.total = total
    this.taskPagination.current = page_num
  }
  public async checkSubTask(text, record) {
    this.renderSubTaskProcess(record.process_id)
    await this.renderSubTaskList(text, 1)
    this.isSubViewVisible = true
    this.currentParentTask = record
  }
  public backToParent(e) {
    this.isSubViewVisible = false
    this.subTaskForm = { ...this.defaultSubTaskFormValue }
    this.subTaskRangeValue = []
  }
  public onSubTaskRangeChange(date, dateString) {
    this.subTaskForm.range = dateString
  }
  public async handleSubTaskFormSubmit(e) {
    const parent_id = this.currentParentTask.task_id
    await this.renderSubTaskList(parent_id, 1)
  }
  public async checkHistory(record: any) {
    let instance = (await getTaskInstance(record.instance_id)) as TaskInstance
    if (!instance || !instance.id) return

    this.subInstanceData = instance
    this.showAuditHistory = true
  }
  public async renderSubTaskList(parent_id: string, page_num) {
    const options = {
      parent_id,
      page_num,
      resource_id: this.subTaskForm.resource_id,
      sample_type: Number(this.subTaskForm.sample_type),
      sensitive_type: Number(this.subTaskForm.sensitive_type),
      only_finished: 0,
      page_size: 10,
      check_at: this.subTaskForm.range[0],
      check_end: this.subTaskForm.range[1],
      process_type: this.subTaskForm.process_type,
      tag: this.subTaskForm.tag
    }
    const { list, total } = await getSubTask(options)
    this.subTaskDataSource = list
    this.subTaskPagination.total = total
    this.subTaskPagination.current = page_num
  }
}
